// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ex-nvr-config-list-item{align-items:center;display:grid;grid-gap:4px;gap:4px}.ex-nvr-config-list__label,.ex-nvr-config-list__value{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ex-nvr-config-list-item:hover .ex-nvr-config-list__label,.ex-nvr-config-list-item:hover .ex-nvr-config-list__value{background:#e9ecef;overflow:visible;text-overflow:clip}.ex-nvr-config-list-item--disabled{color:rgba(51,51,51,.467)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
